import React, { useState, useEffect } from 'react';
import { academyAdminAPI } from '../../lib/academyApi';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';
import { Plus, Pencil, Trash2, Loader2, X } from 'lucide-react';

const AcademyCategories = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', slug: '', description: '', order: 0, is_active: true });

  const fetch = async () => { try { const r = await academyAdminAPI.listCategories(); setItems(r.data); } catch(e){} finally { setLoading(false); } };
  useEffect(() => { fetch(); }, []);

  const openNew = () => { setEditing(null); setForm({ name: '', slug: '', description: '', order: 0, is_active: true }); setShowForm(true); };
  const openEdit = (item) => { setEditing(item.id); setForm(item); setShowForm(true); };

  const handleSave = async () => {
    if (!form.name || !form.slug) { toast.error('Nom et slug requis'); return; }
    try {
      if (editing) { await academyAdminAPI.updateCategory(editing, form); toast.success('Mise a jour'); }
      else { await academyAdminAPI.createCategory(form); toast.success('Creee'); }
      setShowForm(false); fetch();
    } catch(e) { toast.error('Erreur'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer?')) return;
    try { await academyAdminAPI.deleteCategory(id); toast.success('Supprimee'); fetch(); } catch(e) { toast.error('Erreur'); }
  };

  if (loading) return <div className="p-8 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#F9B438]" /></div>;

  return (
    <div className="p-6 lg:p-8" data-testid="academy-categories-admin">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-heading text-2xl font-bold text-[#1D1D1B]">Categories</h1><p className="text-neutral-500 text-sm">{items.length} categorie(s)</p></div>
        <Button onClick={openNew} data-testid="add-category-btn"><Plus className="w-4 h-4 mr-2" />Ajouter</Button>
      </div>
      <div className="space-y-3">
        {items.map(item => (
          <Card key={item.id}><CardContent className="p-4 flex items-center justify-between">
            <div><h3 className="font-medium text-[#1D1D1B]">{item.name}</h3><p className="text-sm text-neutral-500">{item.description}</p></div>
            <div className="flex items-center gap-2">
              <Badge variant={item.is_active ? 'default' : 'secondary'}>{item.is_active ? 'Active' : 'Inactive'}</Badge>
              <Button variant="ghost" size="sm" onClick={() => openEdit(item)}><Pencil className="w-4 h-4" /></Button>
              <Button variant="ghost" size="sm" className="text-red-500" onClick={() => handleDelete(item.id)}><Trash2 className="w-4 h-4" /></Button>
            </div>
          </CardContent></Card>
        ))}
      </div>
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShowForm(false)} />
          <Card className="relative w-full max-w-md z-10">
            <CardHeader className="flex flex-row items-center justify-between"><CardTitle>{editing ? 'Modifier' : 'Ajouter'}</CardTitle><Button variant="ghost" size="sm" onClick={() => setShowForm(false)}><X className="w-4 h-4" /></Button></CardHeader>
            <CardContent className="space-y-4">
              <div><Label>Nom *</Label><Input value={form.name} onChange={e => setForm({...form, name: e.target.value, slug: form.slug || e.target.value.toLowerCase().replace(/[^a-z0-9]/g,'-')})} /></div>
              <div><Label>Slug *</Label><Input value={form.slug} onChange={e => setForm({...form, slug: e.target.value})} /></div>
              <div><Label>Description</Label><Input value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
              <div><Label>Ordre</Label><Input type="number" value={form.order} onChange={e => setForm({...form, order: parseInt(e.target.value)||0})} /></div>
              <div className="flex items-center gap-2"><input type="checkbox" checked={form.is_active} onChange={e => setForm({...form, is_active: e.target.checked})} /><Label>Active</Label></div>
              <div className="flex gap-3"><Button variant="outline" onClick={() => setShowForm(false)} className="flex-1">Annuler</Button><Button onClick={handleSave} className="flex-1">Enregistrer</Button></div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default AcademyCategories;
